'use client';
import {TutorialSteps} from './TutorialSteps';
import styles from './download.module.css';

export function TutorialPage() {
  return <main className={styles.page}><div className={styles.container}><TutorialSteps id="tutorial" standalone/></div></main>;
}
